import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import s from './InputErrorMessage.scss';
/**
 * An error message! Meant to follow an input field.
 */ const InputErrorMessage = (_param)=>{
    var { children, className } = _param, rest = _object_without_properties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("span", _object_spread({
        className: c(s['root'], className),
        // To notify screen reader users of what happened
        "aria-live": "assertive"
    }, rest), children);
};
InputErrorMessage.displayName = 'InputErrorMessage';
export default InputErrorMessage;
